const WHITE_PIN = 
    <div style={{top:'5px', right:'5px', position:'absolute',width:'20px', height:'20px'}}>
        <img src='/images/pin-icon.svg' alt = 'white-pin'></img>
    </div>;

export default WHITE_PIN;